import {convertPicksToHeightInMeter} from './convert-picks-to-height-in-meter';

export function convertPixelsToHeightInMeter(pixels: number, pickDensityInPicksPerMeter: number, nrPicksPerColorline: number): number {
  return convertPicksToHeightInMeter(pixels * nrPicksPerColorline, pickDensityInPicksPerMeter);
}
